import { json, useNavigate, useOutletContext } from 'react-router-dom'
import Axois from '../utils/axios'
import EventEmitter from '../utils/eventEmitter';



export const loadPayments = async (partner_type) => {
  let response = await Axois.get('/payments/all/'+partner_type).catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
    const responseData = await response.data;
    return responseData;
  // return [];
}


export const loadPayment = async (action) => {
  try {
    switch (action) {
      case 'new':
        let requests = await Axois.get('/setups/payments');
        const responseData = await requests.data;
        return {...responseData, payment: {}};
      
      default:
        let response = await Axois.get('/payments/one/'+action);
        const responseJson = await response.data;
        return responseJson;
        // return { positions: [], budgets: [], payments: {}};
    }
  }catch (err) {
    console.log(err);
  }
}



const usePaymentAPI = () => {
  const { success, error } = useOutletContext();
  const navigate = useNavigate();

  const save = async (data, success) => {
    try {
      const response = await Axois.post('/payments', data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('payments_response', data.number);
    }catch(err) {
      console.log(err);
    }
  };


  const update = async (seo, data, success) => {
    try {
      const response = await Axois.put('/payments/'+seo, data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('payments_response', data.seo);
    }catch (err) {
      console.log(err);
    }
  }

  const registerPayment = async (url, data) => {
    try {
      const response = await Axois.post(url, data);
      const responseData = await response.data;
      success(responseData.message);
      setTimeout(() => {
        navigate(0);
      },1000);
    }catch (err) {
      console.log(err);
    }
  }

  return { save, update, registerPayment };
}


export default usePaymentAPI;